import type { ExpertiseCard } from '@/types';

export const EXPERTISE_CARDS: ExpertiseCard[] = [
  {
    id:          'inspection',
    number:      'NO. 01 · INSPECTION',
    category:    'Inspection Dimensionnelle',
    icon:        'Gauge',
    title:       'Inspection Dimensionnelle',
    items:       [
      'Bras Hexagon · CMM · FARO',
      'Instruments conventionnels — micromètres, pieds à coulisse, jauges',
      'GD&T · Tolérances géométriques · ISO / ASME',
      'Contrôle peinture — épaisseur, profil d\'accrochage, arrachement',
      'Points d\'arrêt et inspections finales selon PRIE/ITP',
      'Lecture de plans complexes — usinage, soudure, hydroélectrique',
    ],
    footer:      'Pièces de barrage hydroélectrique · Mazak V655-60 / V515',
    accentClass: 'p',
  },
  {
    id:          'qualite',
    number:      'NO. 02 · QUALITÉ',
    category:    'Système Qualité ISO 9001',
    icon:        'ShieldCheck',
    title:       'Système Qualité ISO 9001',
    items:       [
      'PRIE · ITP · RIF · NCR — montage dossiers qualité complets',
      'Dossiers finaux — NDT, peinture, soudure, sablage, trempe, emballage',
      'Gestion des non-conformités et actions correctives',
      'Audits ISO · Revues de direction · Amélioration continue',
      '5S · AMDEC · Pareto · 5 Pourquoi',
      'KPI qualité — développement et suivi PowerBI / Excel avancé',
    ],
    footer:      'Refonte système qualité CNC Tracy Inc. — 2023',
    accentClass: 'a',
  },
  {
    id:          'transformation',
    number:      'NO. 03 · TRANSFORMATION',
    category:    'Transformation Numérique',
    icon:        'Brain',
    title:       'Transformation Numérique',
    items:       [
      'Automatisation rapports qualité et dossiers d\'inspection',
      'Élimination des tâches sans valeur ajoutée — ressaisie, recopie',
      'Outils dédiés au contexte métier, connectés à l\'ERP existant',
      'Cerveau d\'entreprise — base de connaissances industrielle',
      'Solutions précises à des problèmes réels, pas des démos',
      'IA appliquée — Claude API · Gemini API · modèles locaux',
    ],
    footer:      'Fondateur Asterion Solutions · Lauréat OSEntreprendre 2026',
    accentClass: 't',
  },
  {
    id:          'gmao',
    number:      'NO. 04 · MAINTENANCE',
    category:    'GMAO & Planification',
    icon:        'Settings2',
    title:       'GMAO & Planification',
    items:       [
      'ERP : Notixia · Genius · MS Project',
      'Mise en place et gestion de la GMAO intégrée à l\'ERP',
      'Structuration arborescence machines / bâtiments',
      'MTBF · MTTR · OEE · Rapports automatisés',
      'Maintenance préventive et corrective · Gestion des OT',
      'Planification Gantt · Kanban · Arrêts programmés',
    ],
    footer:      'GMAO intégrée ERP Notixia — CNC Tracy 2023',
    accentClass: 'am',
  },
  {
    id:          'dev',
    number:      'NO. 05 · DEV',
    category:    'Développement & Déploiement',
    icon:        'Server',
    title:       'Développement & Déploiement',
    items:       [
      'Développement structuré — React 19, TypeScript strict, Vite',
      'Firebase (Hosting · Firestore · Auth) · GitLab · Git',
      'Déploiement local — apps sur serveurs dédiés, réseau interne',
      'Intégration ERP locaux — liaison apps ↔ Notixia, Genius',
      'Microsoft 365 — Power Automate, PowerApps, intégrations API',
      'SaaS multi-tenant — Asterion Solutions, 6 apps en production',
    ],
    footer:      'Asterion Solutions · outils internes CNC Tracy déployés',
    accentClass: 'ci',
  },
  {
    id:          'cao',
    number:      'NO. 06 · CAO & DONNÉES',
    category:    'CAO/DAO · Analyse de Données',
    icon:        'BarChart3',
    title:       'CAO/DAO · Analyse de Données',
    items:       [
      'SolidWorks · SolidEdge · CATIA V5/V6',
      'Modélisation 3D · mise en plan · documentation technique',
      'Cotation fonctionnelle et tolérancement géométrique (GD&T)',
      'PowerBI — tableaux de bord KPI · performance · fiabilité',
      'Excel avancé — formules complexes, macros, automatisation',
      'Suite Office 365 — Word, Project, Teams, SharePoint avancé',
    ],
    footer:      'DUT Génie Mécanique (Toulouse, 2012) · ÉNA Tolérances (2018)',
    accentClass: 'm',
  },
];
